// extracted by mini-css-extract-plugin
export default {"fab":"feedback_fab__f3LDq","content":"feedback_content__jp7EC"};